<mat-card appearance="outlined">
    <div class="row">
        <div class="col">
            <p>
                <strong>¿Seguro que quiere eliminar esta cuenta contable?</strong>
            </p>
            <div class="btns">
                <button mat-stroked-button (click)="delete()">Eliminar</button>
                <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
            </div>
        </div>
    </div>
</mat-card>